import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler
} from "react-native";
import HMActionBar from "../../../../customviews/HMActionBar";
const {width: SCREEN_WIDTH} = Dimensions.get("window");
import i18n from '../../../../I18n/i18n.js';
import {moderateScale} from "../../../../tools/Scaling";
import  Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import HMListItem2 from "../../../../customviews/HMListItem2";

let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;

//import moment from 'jalali-moment';
import HMMap from "../../../../customviews/map/HMMap";
import HMIcon from "../../../../customviews/HMIcon";

//().locale('fa').format('YYYY/M/D');
const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}


export default class DetailsRegisterComplaintsScreen extends Component {
    static navigationOptions = ({navigation}) => {
        const {state} = navigation
        // Setup the header and tabBarVisible status
        const header = state.params && (state.params.fullscreen ? undefined : null)
        const tabBarVisible = state.params ? state.params.fullscreen : true
        return {
            // For stack navigators, you can hide the header bar like so
            header,
            // For the tab navigators, you can hide the tab bar like so
            tabBarVisible,
        }
    }

    constructor(props) {
        super(props);
        container = this;
        this.state = {

            modalHeight: 0,
            isFull: false,


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
        };
        this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props

    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            () => {
               /* Orientation.unlockAllOrientations();
                Orientation.lockToPortrait();*/
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }

    onFullScreen = (value) => {
        // Set the params to pass in fullscreen status to navigationOptions
        this.props.navigation.setParams({
            fullscreen: !value
        })
        if (value) {
          //  Orientation.lockToLandscape();
        } else {
          /*  Orientation.unlockAllOrientations();
            Orientation.lockToPortrait();*/
        }
        this.setState({
            isFull: value
        })
    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [Constants.Longitude, Constants.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            //mode: MapboxGL.CameraModes.Flight,
        });

    }

    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    async componentDidMount() {

        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        })


    }

    componentWillMount() {
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;
       BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

    }

    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };

    render() {
        const url = 'https://your-url.com/video.mp4'
        const logo = 'https://your-url.com/logo.png'
        const placeholder = 'https://your-url.com/placeholder.png'
        const titleVideo = 'My video title'

        let {title,topic,place,topiccate,person, description, latitude, longitude, address, code, status, files, createdtime, comment, video, image, subject, date, category,} = this.props.route.params.item;
        let checkVideo = video ? video : (files && files.length > 0 && files.find(k => k.type === 'video/mp4'));
        let checkImage = image ? image : (files && files.length > 0 && files.find(k => k.type === 'image/jpeg'));
        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar menu
                                     props={this.props} statusBarTransparent
                                     text={i18n.t('Privatizations.title')}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />

                        <ScrollView
                            // ref={scroll => this._onRef('_scroll', scroll)}
                            style={{
                                //  backgroundColor: "white"
                            }}>

                            <View style={{flex: 1,}}>
                                {
                                    latitude && latitude != null && latitude != '' ?
                                        <View onPress={() => {
                                        }
                                            /*  NavigationService.navigateParams("MapShowScreen", {
                                               //   latitude: data.latitude, longitude: data.longitude
                                              })*/
                                        } style={{width: "100%", height: moderateScale(200)}}>
                                            <HMMap
                                                ref={ref => (this.map = ref)}
                                                style={{
                                                    width: "100%",
                                                    //height:height-moderateScale(200),
                                                    height: "100%", marginBottom: this.state.marginBottom
                                                }}
                                                initialRegion={{
                                                    latitude: parseFloat(latitude),
                                                    longitude:  parseFloat(longitude ),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}
                                                coordinate={{
                                                    latitude: parseFloat(latitude),
                                                    longitude:  parseFloat(longitude ),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}
                                            >
                                               {/* <MapView.Marker coordinate={{
                                                    latitude: parseFloat(latitude),
                                                    longitude:  parseFloat(longitude ),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}/>*/}

                                            </HMMap>

                                            {/*<MapboxGL.MapView*/}
                                                {/*//showUserLocation={true}*/}
                                                {/*ref={ref => (this.map = ref)}*/}

                                                {/*zoomLevel={15}*/}
                                                {/*//  userTrackingMode={MapboxGL.UserTrackingModes.Follow}*/}
                                                {/*//  styleURL={this.state.styleURL}*/}
                                                {/*style={{*/}
                                                    {/*width: "100%",*/}
                                                    {/*height: "100%",*/}
                                                {/*}}*/}
                                                {/*centerCoordinate={[parseFloat(longitude), parseFloat(latitude)]}*/}

                                                {/*// onDidFinishLoadingMap={this.onDidFinishLoadingMap}*/}
                                                {/*//onRegionWillChange={this.onRegionWillChange}*/}
                                                {/*//  onRegionDidChange={this.onRegionDidChange}*/}
                                                {/*//   onRegionDidChange={(a)=>{}}*/}
                                                {/*//  onRegionIsChanging={this.onRegionIsChanging}*/}
                                                {/*// onUserLocationUpdate={this.onUserLocationUpdate}*/}
                                            {/*>*/}
                                                {/*<MapboxGL.PointAnnotation*/}
                                                    {/*key="key1"*/}
                                                    {/*id="id1"*/}
                                                    {/*title="Test"*/}
                                                    {/*zoomLevel={16}*/}
                                                    {/*// coordinate={[Constants.Longitude, Constants.Latitude]}*/}
                                                    {/*coordinate={[parseFloat(longitude), parseFloat(latitude)]}*/}
                                                {/*>*/}

                                                    {/*<Icon*/}
                                                        {/*raised*/}
                                                        {/*name='md-pin'*/}
                                                        {/*color={Colors.gray}*/}
                                                        {/*style={{*/}
                                                            {/*fontSize: moderateScale(22),*/}
                                                            {/*color: Colors.colorSecondPrimary,*/}
                                                            {/*textAlign: "center",*/}

                                                            {/*// padding: moderateScale(4),*/}

                                                        {/*}}*/}
                                                    {/*/>*/}
                                                    {/*<MapboxGL.Callout title={title}/>*/}
                                                {/*</MapboxGL.PointAnnotation>*/}
                                            {/*</MapboxGL.MapView>*/}


                                            {
                                                // address ?
                                                1 === 1 ?
                                                    <TouchableOpacity
                                                        onPress={() => this.centerMap(parseFloat(longitude), parseFloat(latitude))}
                                                        style={{
                                                            flexDirection: "row",
                                                            padding: moderateScale(5),
                                                            //     justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            width: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.4)",
                                                            position: "absolute",
                                                            bottom: 0,
                                                            left: 0
                                                        }}>
                                                        {/*      <TextView textt={data.address} selfStyle={{
                                            marginHorizontal: moderateScale(10),
                                            color: "white",
                                            fontSize: moderateScale(14),
                                            textAlign: "right",
                                            flex: 1
                                        }}/>*/}
                                                        <HMIcon type={"Feather"}                                                 name={"map-pin"}
                                                              style={{
                                                                  marginEnd: moderateScale(10),
                                                                  fontSize: moderateScale(22),
                                                                  color: Colors.white
                                                              }}/>
                                                        <HMTextView

                                                            type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: Colors.light3,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            //text={'اراک خ هپکو خ امام حسین'}
                                                            text={address}
                                                            //   text={"98/03/21"}
                                                        />

                                                    </TouchableOpacity>
                                                    :
                                                    null
                                            }

                                        </View>
                                        : null
                                }
                                <HMListItem2
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(8)}}
                                    title={topic}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"عنوان"}

                                />
                                <HMListItem2
                                    title={place}
                                   // file={"video"}
                                   // props={this.props}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"ios-pin"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //this.onShare()
                                    }}
                                    text={"آدرس"}

                                />
                                <HMListItem2
                                    title={person}
                                   // file={"image"}
                                    //path={checkImage ? files.find(k => k.type === 'image/jpeg').file : image}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"ios-people"}
                                    NoShowIconOnpress
                                    text={"شخص"}

                                />
                                {/*  <HMListItem2
                                    // title={"معرفی دوستان"}

                                    title={"درخواست جمع آوری متکدیان اجتماعی"}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-paper"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />*/}
                                <HMListItem2
                                    // title={"معرفی دوستان"}
                                    title={createdtime ? createdtime : date}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-calendar"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"تاریخ"}

                                />
                                <HMListItem2
                                    title={description}
                                    // title={"به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید، تا از نظر گرافیکی نشانگر چگونگی نوع و اندازه فونت و ظاهر متن باشد. معمولا طراحان گرافیک برای صفحه‌آرایی، نخست از متن‌های آزمایشی و بی‌معنی استفاده می‌کنند تا صرفا به مشتری یا صاحب کار خود نشان دهند که صفحه طراحی یا صفحه بندی شده بعد از اینکه متن در آن قرار گیرد چگونه به نظر می‌رسد و قلم‌ها و اندازه‌بندی‌ها چگونه در نظر گرفته شده‌است. از آنجایی که طراحان عموما نویسنده متن نیستند و وظیفه رعایت حق تکثیر متون را ندارند و در همان حال کار آنها به نوعی وابسته به متن می‌باشد آنها با استفاده از محتویات ساختگی، صفحه گرافیکی خود را صفحه‌آرایی می‌کنند تا مرحله طراحی و صفحه‌بندی را به پایان برند."}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-list-box"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"توضیحات"}

                                />



                                <View
                                    style={{
                                        flex: 1,
                                    }}>
                                    <View style={{

                                        flexDirection: 'row',
                                        ///  backgroundColor:'#a8ee7c',
                                        marginHorizontal: moderateScale(5),
                                        marginTop: moderateScale(8),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                    }}>
                                        <HMTextView


                                            type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.blackLight,
                                                textAlign: 'center',
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={i18n.t('constant.PublicCommunicationsCenterResponse')}
                                            //   text={"98/03/21"}
                                        />


                                    </View>
                                    <FlatList
                                        // ItemSeparatorComponent={
                                        //     <View style={{
                                        //         width: '100%',
                                        //         height: moderateScale(1),
                                        //         backgroundColor: '#4f4f4f'
                                        //     }}/>
                                        // }
                                        data={comment === null || !comment ? [] : comment}
                                        renderItem={({item, index}) =>
                                            <View style={{
                                                // width: "100%",
                                                flex: 1,
                                                marginHorizontal: moderateScale(10),
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>
                                              {/*  <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                    }}>*/}
                                                        <View
                                                            style={{
                                                                //paddingVertical: moderateScale(10),
                                                                width: '100%',

                                                                padding: moderateScale(6)
                                                            }}
                                                        >


                                                            <View style={{flexDirection: 'row', alignSelf: "center",}}>
                                                                <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(12),
                                                                        color: Colors.colorDarkText,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={item.datetime}
                                                                    // text={moment(item.datetime).locale('fa').format('YYYY/M/D HH:mm:ss')}
                                                                    /*           text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                                   .locale('fa')
                                                                                   .format('YYYY/M/D HH:mm:ss')}  */

                                                                    //  text={moment(item.datetime, 'YYYY-M-D HH:mm:ss').locale('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                                    /*      text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                              .locale('fa')
                                                                              .format('YYYY/M/D HH:mm:ss')}*/
                                                                    // text={moment('2013-8-25 16:00:00', 'YYYY-M-D HH:mm:ss').local('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                                    //
                                                                    //
                                                                    // text={new Date('2013-8-25 16:40:00').toLocaleTimeString('fa-Ir')}
                                                                />
                                                            </View>
                                                            <View style={{
                                                                width: '100%',
                                                                height: moderateScale(1),
                                                                backgroundColor: '#eee',
                                                                alignSelf: 'center'
                                                            }}/>
                                                            <View style={{
                                                                flexDirection: 'row',
                                                                flex: 1,
                                                                marginVertical: moderateScale(6),
                                                                marginHorizontal: moderateScale(3)
                                                            }}>
                                                                <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(12),
                                                                        color: Colors.colorDark,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={item.comment}
                                                                    //   text={"98/03/21"}
                                                                />
                                                            </View>
                                                            {/*   <View style={{
                                                            width: '100%',
                                                            height: moderateScale(1),
                                                            backgroundColor: '#4f4f4f'
                                                        }}/>*/}


                                                        </View>
                                             {/*       </CardItem>
                                                </Card>*/}
                                            </View>
                                        }
                                    />


                                </View>
                            </View>

                        </ScrollView>

                        {
                            this.state.visibleModal === 'selectVideo' ?
                                <View style={{
                                    position: 'absolute',
                                    flex: 1,
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',

                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0,
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    zIndex: 9900
                                }}>
                                    <View style={{
                                        height: "100%",
                                        width: '100%',
                                        // padding: moderateScale(6),
                                        backgroundColor: Colors.black
                                    }}>


                                    </View>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this.hiddenModal()
                                        }}

                                        style={{
                                            width: moderateScale(32),
                                            height: moderateScale(32),
                                            // backgroundColor: '#ee005b',
                                            position: 'absolute',
                                            borderRadius: moderateScale(16),
                                            margin: moderateScale(4),
                                            top: 0,
                                            left: 0,
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                        <HMIcon name={"ios-close-circle-outline"} style={{
                                            textAlign: 'center',
                                            //alignSelf: 'flex-end',
                                            color: Colors.white,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(22)
                                        }}/>
                                    </TouchableOpacity>
                                </View>
                                : null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

